import React from 'react';

const Services = () => {
  const services = [
    {
      name: 'Full Head of Foils',
      variants: [
        { label: 'Regrowth only', price: '$220' },
        { label: 'Regrowth + ends', price: '$240' },
      ],
      description: "The ultimate blonde appointment, ideal for all over brightness. Leaving you with a seamless blonde that's tailored just for you.",
    },
    {
      name: '3/4 Head of Foils',
      variants: [
        { label: 'Regrowth only', price: '$205' },
        { label: 'Regrowth + ends', price: '$225' },
      ],
      description: "The perfect in between when you don't quite need a full head, but you like to tie your hair up!",
    },
    {
      name: '1/2 Head of Foils',
      variants: [
        { label: 'Regrowth only', price: '$165' },
        { label: 'Regrowth + ends', price: '$185' },
      ],
      description: 'This service refreshes the most visible areas, keeping your blonde looking fresh and adding brightness through the top and around the face.',
    },
    {
      name: '1/4 Head of Foils',
      variants: [
        { label: 'Regrowth only', price: '$140' },
        { label: 'Regrowth + ends', price: '$160' },
      ],
      description: 'The perfect express blonde refresh, focusing on your part line and around the face frame.',
    },
    { name: 'Face Frame Foils', description: 'The ultimate mini refresh, focusing on around your face for that pop of brightness between bigger foil appointments.', price: '$100' },
    { name: 'All Over Colour', description: 'A complete colour refresh, with one seamless colour from roots to ends.', price: '$150' },
    { name: 'Root Colour', description: 'Customised to your desired level of depth, used for full grey coverage, adding depth at the roots or even to blur unwanted greys coming through.', price: '$100' },
    { name: 'Toner', description: 'The finishing touch to your colour service, we customise toner to enhance your colour, add shine and leave your hair looking fresh.', price: '$60' },
    { name: 'Gloss', description: 'Keep your colour looking fresh between appointments with a customised gloss. Adding pigment and all over shine.', price: '$80' },
    { name: 'Haircut', description: 'Includes wash, cut & blowdry/style. Personalised haircuts for bob-length hair and longer. Unfortunately we do not offer anything shorter than these lengths.', price: '$80' },
    { name: 'Wash & Blowdry (Shoulder+)', description: 'Luxury wash and styling for shoulder length and above', price: '$60', duration: '45 mins' },
    { name: 'Wash & Blowdry (Long)', description: 'Luxury wash and styling for hair below shoulders', price: '$70', duration: '1 hr' },
    { name: 'Wellaplex BondBuilder', description: 'Built into a specific lightener we use, this helps keep your hair strong and healthy during lightening services. Recommended add on to all blonding services.', price: '$40' },
    {
      name: 'BHave Smooth Treatment',
      variants: [
        { label: 'Above shoulder', price: '$400' },
        { label: 'Long hair', price: '$450' },
      ],
      description: 'Perfect for anyone struggling with frizzy or unruly hair. This service requires an in person consult prior to booking, please message us to organise a time.',
    },
  ];

  return (
    <section id="services" className="py-16 md:py-32 bg-gray-50 relative overflow-hidden">
      {/* Sparkles */}
      <div className="sparkle-container">
        <div className="sparkle sparkle-1" style={{ background: 'rgba(130, 162, 132, 0.6)' }}></div>
        <div className="sparkle sparkle-2" style={{ background: 'rgba(130, 162, 132, 0.4)' }}></div>
        <div className="sparkle sparkle-3" style={{ background: 'rgba(130, 162, 132, 0.7)' }}></div>
        <div className="sparkle sparkle-4" style={{ background: 'rgba(130, 162, 132, 0.5)' }}></div>
        <div className="sparkle sparkle-5" style={{ background: 'rgba(130, 162, 132, 0.6)' }}></div>
        <div className="sparkle sparkle-6" style={{ background: 'rgba(130, 162, 132, 0.3)' }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block">
            <div className="w-10 md:w-12 h-0.5 bg-sage-600 mb-3 md:mb-4"></div>
            <p className="text-sage-600 font-light tracking-widest text-xs md:text-sm mb-3 md:mb-4">OUR SERVICES</p>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif italic text-gray-900 mb-4 md:mb-6">
            Service Menu
          </h2>
        </div>

        {/* Services List - Two Column Layout */}
        <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12 mb-8">
          {/* Pricing Disclaimer */}
          <div className="bg-sage-50 border-l-4 border-sage-600 p-6 mb-8 rounded-r-lg">
            <p className="text-sm text-gray-700 font-light leading-relaxed">
              <strong className="font-normal text-sage-700">Please Note:</strong> The prices below are a guide only. Additional costs may apply due to product usage and time requirements. Services are priced individually – simply add together the services you'd like for your total cost.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-8">
            {services.map((service, idx) => (
              <div key={idx} className="border-b border-gray-100 last:border-0 pb-6">
                {service.variants ? (
                  <>
                    <h4 className="text-lg font-normal text-gray-900 mb-2">{service.name}</h4>
                    <div className="space-y-1 mb-2">
                      {service.variants.map((variant, vIdx) => (
                        <div key={vIdx} className="flex justify-between items-baseline">
                          <span className="text-sm text-gray-600 font-light">{variant.label}</span>
                          <span className="text-lg font-normal text-sage-600 ml-4">{variant.price}</span>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="text-lg font-normal text-gray-900 flex-1">{service.name}</h4>
                    <span className="text-xl font-normal text-sage-600 ml-4">{service.price}</span>
                  </div>
                )}
                <p className="text-sm text-gray-600 font-light mb-2">{service.description}</p>
                {service.duration && (
                  <p className="text-xs text-gray-500 font-light">{service.duration}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="sms:0475409162"
            className="inline-flex items-center justify-center bg-gray-900 text-white px-10 py-4 rounded-full hover:bg-gray-800 transition-all duration-300 font-normal tracking-wider text-sm shadow-lg"
          >
            BOOK YOUR SERVICE
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;